<template>
  <!-- 主页布局 -->
  <div>index</div>
</template>

<script>
export default {
  name: "Index",
  mounted() {},
};
</script>
<style scoped>
</style>
